import { EXTERNAL_URLS } from '@/constants/urls';

/**
 * The text a referral carries: the pitch, then the link, as ONE string.
 *
 * Both clients hand the result to a single sink — the clipboard on web, the
 * share sheet's one activity item on mobile. Passing the URL a second time
 * alongside it is what made iOS paste the link twice and let Messages drop the
 * pitch altogether, so the URL belongs here and nowhere else in the payload.
 */
export function buildShareText(message: string): string {
  return `${message} ${EXTERNAL_URLS.VOTEMATE_WEBSITE}`;
}
